import { useEffect, useState } from 'react';
import { useApi } from '../../hooks/useApi';
import styles from './settings.module.css';
import { useStores } from '../../hooks/useStore';
import { observer } from 'mobx-react';

import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from '@mui/material';
import { Button } from '../../components/UI/Button/Button';
import { ReactComponent as EditIco } from './icon/edit.svg';
import { SettingModel } from '../../models/settings';
import SettingPopUP from '../../components/popUp/Settings/Settings';

const Settings: React.FC = observer(() => {
  const api = useApi();
  const store = useStores();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const [showForm, setShowForm] = useState<boolean>(false);

  const [settings, setSettings] = useState<SettingModel[]>([]);
  const [setting, setSetting] = useState<SettingModel | null>(null);

  useEffect(() => {
    loadSettings();
  }, [page, rowsPerPage]);

  const loadSettings = async () => {
    try {
      store.notificationsStore.showPreloader();
      const { body } = await api.settings.get(page * rowsPerPage, rowsPerPage);

      if (body) {
        setSettings(body);
      }
    } catch (e) {
      store.notificationsStore.setError('Ошибка при загрузке');
    } finally {
      store.notificationsStore.hidePreloader();
    }
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const closeForm = () => {
    setShowForm(false);
    setSetting(null);
  };

  const update = () => {
    loadSettings();
  };

  const editItem = (item: SettingModel) => {
    setSetting(item);
    setShowForm(true);
  };

  return (
    <>
      {showForm && (
        <SettingPopUP onClose={closeForm} update={update} item={setting} />
      )}
      <div className={styles.container}>
        <div className={styles.pageName}>
          <div className={styles.top}>
            <div className={styles.title}>
              <h2>Настройки</h2>
            </div>
            <Button
              style={{ maxWidth: 150 }}
              appearance="auth"
              onClick={() => setShowForm(showForm ? false : true)}
            >
              Добавить
            </Button>
          </div>
        </div>

        <div style={{ width: '100%', maxWidth: 1500, margin: '5px' }}>
          <Paper
            sx={{
              width: '100%',
              maxWidth: 1500,
              margin: '5px',
              overflowX: 'auto',
            }}
          >
            <TableContainer style={{ marginTop: 20, overflowX: 'auto' }}>
              <Table sx={{ minWidth: 320 }}>
                <TableHead>
                  <TableRow>
                    <TableCell>Ключ</TableCell>
                    <TableCell align="right">Значение</TableCell>
                    <TableCell align="right">Описание</TableCell>
                    <TableCell align="right">Действие</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {settings &&
                    settings.map((row) => (
                      <TableRow
                        key={row.id}
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {row.key}
                        </TableCell>
                        <TableCell align="right">{row.value}</TableCell>
                        <TableCell align="right">{row.description}</TableCell>

                        <TableCell align="right">
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              justifyContent: 'flex-end',
                              alignItems: 'center',
                            }}
                          >
                            <EditIco
                              className={styles.tagDeleteIco}
                              onClick={() => {
                                editItem(row);
                              }}
                            />
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
            <div
              style={{ width: '100%', height: 1, backgroundColor: '#E0E0E0' }}
            />
            <TablePagination
              labelRowsPerPage="Строк на странице"
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={settings ? settings.length : 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </div>
      </div>
    </>
  );
});

export default Settings;
